module.exports = __webpack_public_path__ + "static/img/img25.e5d56f76.png";